import PropTypes from "prop-types";
import React from "react";
import { FormText } from "react-bootstrap";
import { Link } from "react-router-dom";
import ReactToggle from "react-toggle";

import { PRIORITY } from "./utils";

function hasOverride(priority, priorities) {
  return priorities.some((ps) => ps.priority < priority);
}

function isOverriding(priority, priorities) {
  const hasLevel = priorities.some((ps) => ps.priority === priority);
  const hasLowerPriority = priorities.some((ps) => ps.priority < priority);

  return hasLevel && hasLowerPriority;
}

class Toggle extends React.PureComponent {
  static get propTypes() {
    return {
      children: PropTypes.element.isRequired,
      disabled: PropTypes.bool,
      defaultValue: PropTypes.bool,
      onChange: PropTypes.func,
    };
  }

  static get defaultProps() {
    return {
      defaultValue: false,
    };
  }

  constructor(props) {
    super(props);
    this.state = {
      isOn: props.defaultValue,
    };

    this._onChange = this._onChange.bind(this);
  }

  _onChange(e) {
    const { checked } = e.currentTarget;
    this.props.onChange(checked);
  }

  render() {
    const { children, disabled } = this.props;
    const { isOn } = this.state;

    return (
      <FormText className="font-smaller">
        <span className="d-flex flex-vertical-align">
          <ReactToggle
            defaultChecked={isOn}
            disabled={disabled}
            onChange={this._onChange}
            className="toggle-cortex toggle-sm mr-4 mt-2"
            icons={false}
          />
          {children}
        </span>
      </FormText>
    );
  }
}

function Label(props) {
  const { hasDefaultValue, hasNetworkLevel, networkId, priority } = props;

  if (priority >= PRIORITY.DEVICE && hasNetworkLevel) {
    const link = (
      <Link to={`/networks/${networkId}/configure`}>network level</Link>
    );

    return <span>Override {link} value.</span>;
  }

  if (priority >= PRIORITY.NETWORK && hasDefaultValue) {
    return <span>Override default application value.</span>;
  }

  return <span>Override value.</span>;
}

Label.propTypes = {
  hasDefaultValue: PropTypes.bool,
  hasNetworkLevel: PropTypes.bool,
  networkId: PropTypes.number.isRequired,
  priority: PropTypes.oneOf([PRIORITY.DEVICE, PRIORITY.NETWORK]).isRequired,
};

Label.defaultProps = {
  hasDefaultValue: false,
  hasNetworkLevel: false,
};

export default {
  hasOverride,
  isOverriding,
  Label,
  Toggle,
};
